import { orgServiceApiSlice } from "state/services/orgServiceApiSlice";

// The `orgServiceApiSlice` object is used to generate hooks that can be used to make API calls to the org service.
const orgServiceApiQueries = orgServiceApiSlice.injectEndpoints({
  // The `endpoints` object is used to define the API endpoints for the org service.
  endpoints: (builder) => ({
    // The `getOrgById` query is used to retrieve an organization by its ID.
    getOrgById: builder.query({
      query: (orgId) => ({
        url: `/organizations/${orgId}`,
      }),
      transformResponse: (responseData) => {
        return responseData;
      },
      providesTags: ["Organization"],
    }),
    getActiveOrganizations: builder.query({
      // Accept an optional arg object: { platformId, includeSyncConfig }
      query: ({ platformId, includeSyncConfig } = {}) => {
        const platformParam = platformId ? `&platform_id=${platformId}` : "";
        const syncParam = includeSyncConfig ? "&include_sync_config=true" : "";
        return { url: `/organizations?status=Active${platformParam}${syncParam}` };
      },
      transformResponse: (responseData) => responseData.organizations,
      providesTags: ["Organization"],
    }),
    getInProgressOrganizations: builder.query({
      query: ({ platformId } = {}) => {
        const platformParam = platformId ? `&platform_id=${platformId}` : "";
        return { url: `/organizations?status=In-Progress${platformParam}` };
      },
      transformResponse: (responseData) => responseData.organizations,
      providesTags: ["Organization"],
    }),
    updateOrganization: builder.mutation({
      query: ({ orgId, updateData }) => ({
        url: `/organizations/${orgId}`,
        method: 'PATCH',
        body: updateData
      }),
      invalidatesTags: ["Organization"],
    }),
  }),
});

export const { useGetOrgByIdQuery, useGetActiveOrganizationsQuery, useGetInProgressOrganizationsQuery, useUpdateOrganizationMutation } = orgServiceApiQueries;
